// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = __webpack_require__("./cartridges/int_trustpilot/cartridge/client/default/js/trustpilotWidget.js");
